import * as React from "react";
import { SVGProps } from "react";
const SvgReload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.333 15.159c.251 0 .477.11.63.284 1.585 1.375 3.113 3.63 3.756 5.379a.84.84 0 0 1-1.577.58c-.39-1.06-1.195-2.387-2.118-3.491-.917 5.814-5.95 10.26-12.02 10.26a12.147 12.147 0 0 1-9.188-4.184.841.841 0 0 1 1.268-1.103 10.466 10.466 0 0 0 7.919 3.607c5.327 0 9.725-3.97 10.4-9.112-1.356.75-2.715 1.84-3.5 2.79a.84.84 0 1 1-1.296-1.068c1.206-1.463 3.452-3.118 5.428-3.875l-.14.055a.836.836 0 0 1 .438-.123v.001ZM16 3.829c3.57 0 6.89 1.544 9.187 4.184a.84.84 0 0 1-1.268 1.103A10.464 10.464 0 0 0 16 5.508c-5.326.001-9.726 3.972-10.4 9.114 1.356-.75 2.714-1.839 3.496-2.788a.84.84 0 0 1 1.297 1.068c-1.142 1.385-3.219 2.944-5.114 3.748l-.182.075a.837.837 0 0 1-.944-.062l-.081-.072C2.476 15.22.929 12.943.28 11.181a.84.84 0 0 1 1.577-.58c.39 1.06 1.196 2.388 2.12 3.493C4.894 8.278 9.928 3.83 16 3.83v-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgReload;
